import React from 'react';
import { Hyperlink } from '../../types/hyperlink.types';
import { HyperLink } from './HyperLink';

interface Props {
  items: Hyperlink[];
  entityName: string;
  entityId: number;
  onDelete: () => void;
  onRename: () => void;
}

export const HyperLinkList = ({ items, entityName, entityId, onDelete, onRename }: Props) => {
  return (
    <>
      {items.map((hyperlink, i) => {
        return (
          <HyperLink
            key={i}
            id={hyperlink.id}
            name={hyperlink.name}
            url={hyperlink.uri}
            entityName={entityName}
            entityId={entityId}
            onDelete={onDelete}
            onRename={onRename}
          />
        );
      })}
    </>
  );
};
